import { useHistory, useLocation } from 'react-router-dom'

import {
  addParam,
  currentPathWithView,
  pathToSignInPage,
  pathWithCurrentView,
  pathWithView,
} from './appUrl'

/**
 * Wraps useAppHistory from react-router-dom to automatically preserve
 * map state in URL.
 */
export const useAppHistory = () => {
  const history = useHistory()
  const location = useLocation()

  const pushWithMapState = (to, state) => {
    let newTo
    if (typeof to === 'string') {
      newTo = pathWithCurrentView(to)
    } else {
      newTo = { ...to }
      if (to.pathname != null) {
        newTo.pathname = pathWithCurrentView(to.pathname)
      }
    }

    history.push(newTo, state)
  }
  const replaceWithMapState = (to) => {
    const newTo = pathWithCurrentView(to)
    history.replace(newTo)
  }

  const syncViewToBrowserUrl = (newView) => {
    const newPath = currentPathWithView(newView)
    const oldPath = window.location.pathname
    if (oldPath !== newPath) {
      window.history.pushState(null, '', newPath)
    }
  }

  const replaceView = (newView, state) => {
    const newUrl = currentPathWithView(newView)
    history.replace(newUrl, state)
  }

  const removeParam = (paramName) => {
    const searchParams = new URLSearchParams(location.search)
    searchParams.delete(paramName)
    const newSearch = searchParams.toString()
    const newPath = `${location.pathname}${newSearch ? `?${newSearch}` : ''}`
    history.replace(newPath)
  }

  const addParamToHistory = (paramName, paramValue, state) => {
    const currentPath = `${location.pathname}${location.search}`
    const newPath = addParam(currentPath, paramName, paramValue)
    history.push(newPath, state)
  }

  const pushToSignInPage = () => {
    const signInPath = pathToSignInPage()
    history.push(signInPath)
  }

  const pushAndChangeView = (path, view, state) => {
    const newUrl = pathWithView(path, view)
    history.push(newUrl, state)
  }

  return {
    ...history,
    push: pushWithMapState,
    replace: replaceWithMapState,
    syncViewToBrowserUrl,
    replaceView,
    removeParam,
    addParam: addParamToHistory,
    pushToSignInPage,
    pushAndChangeView,
  }
}
